import { RegularDocument } from 'components/icon/regular'

import css from './table-no-results.module.scss'

export const NoResults = ({ message, icon = <RegularDocument /> }: { message: string; icon?: JSX.Element }) => (
  <div className={css.container}>
    <div className={css.icon}>{icon}</div>
    <div className={css.label}>{message}</div>
  </div>
)
